import { Button, CircularProgress, styled } from '@material-ui/core';
import React from 'react';
import { PropTypes } from 'prop-types';
export const ButtonCircularProgress = styled(CircularProgress)({
    height: '20px !important',
    width: '20px !important',
    color: 'white'
});
const CustomizedCancelButton = styled(({ ...props }) => <Button {...props} />)((props) => ({
    minWidth: props.fullWith ? '100%' : props.width ? props.width + 'px' : '80.5px',
    minHeight: '40px',
    // borderRadius: (props) => (props.isMobile ? '4px' : '23px'),
    color: props.customColor ? props.customColor : '#ef1734',
    border: `solid 2px ${props.customColor ? props.customColor : '#ef1734'}`,
    marginRight: props.mr ? '' + 'px' : '14px',
    backgroundColor: '#fff',
    '&:hover': {
        backgroundColor: props.customColor ? props.customColor : '#ef1734',
        color: '#fff'
    }
}));

export default function SubmitButton(props) {
    return (
        <CustomizedCancelButton {...props} type={'button'} variant={'outlined'}>
            {props.children || <span>{props.cancelText ? props.cancelText : 'cancel'} </span>}
        </CustomizedCancelButton>
    );
}
SubmitButton.propTypes = {
    cancelText: PropTypes.string,
    handleClick: PropTypes.func,
    mr: PropTypes.string,
    width: PropTypes.string,
    children: PropTypes.any
};
